import { render, staticRenderFns } from "./string-renderer.vue?vue&type=template&id=b139e618&"
import script from "./string-renderer.vue?vue&type=script&lang=js&"
export * from "./string-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports